import * as React from "react";
import {cx} from "emotion";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke}    from "@Common/react/invoke";
import {keyed}     from "@Common/react/keyed";
import {scnv}      from "@Common/react/state-change-nested-value";
import {UseState}  from "@Common/react/use-state";

export const ProofViewer = ({currentImgIndex, next}) => cs(
    ["loadingImageSize", (_, next) => UseState({next})],
    ["loadedImages", (_, next) => UseState({next})],
    ({loadingImageSize, loadedImages}) => next({
        size: loadedImages.value?.[currentImgIndex] ?? loadingImageSize.value,
        render: ({visible, images}) => cs(
            ({}) => <>
                {images?.map((imgSrc, i) => cs(
                    keyed(imgSrc),

                    ({}, next) => fragments(
                        Invoke({
                            action: () => scnv(loadedImages, [i], () => null),
                        }),
                        next(),
                    ),
                    () => (
                        <div {...{
                            className: cx(visible && currentImgIndex === i ? "show" : "hide"),
                        }}>
                            <img {...{
                                src: imgSrc,
                                onLoad: (e:React.SyntheticEvent<EventTarget>) => {
                                    const size = {
                                        width: e.target.naturalWidth,
                                        height: e.target.naturalHeight,
                                    };
                                    scnv(loadedImages, [i], () => size);
                                },
                            }}/>
                        </div>
                    ),
                ))}

                <div className={cx("image", visible && !loadedImages.value?.[currentImgIndex] ? "show" : "hide")}>
                    <img {...{
                        src: "assets/SPINNER.svg",
                        onLoad: (e:React.SyntheticEvent<EventTarget>) => {
                            loadingImageSize.onChange({
                                width: e.target.naturalWidth,
                                height: e.target.naturalHeight,
                            });
                        },
                    }}/>
                </div>
            </>,
        ),
    })
);